import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UsuarioSeguridadModel } from '../models/usuarioSeguridad.model';
import { moduloSeguridad } from '../diccionarios/seguridadModulo.js';
import { map } from 'rxjs/operators';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  mdSeguridad: any;
  url: any;
  urlLdap: any;

  constructor(
    private http: HttpClient,
    private _commom: CommonService,
    private _util: UtilsService
  ) {
    this.mdSeguridad = moduloSeguridad;
    this.url = _util.getSeguridad(this.mdSeguridad.url.seguridad.usuario);
    this.urlLdap = _util.getSeguridad(this.mdSeguridad.url.seguridad.buscarLdap);
  }

  getAll(): Observable<UsuarioSeguridadModel[]> {
    // const headers = this._util.getHeaders();
    // return this.http.get<UsuarioSeguridadModel>(this.url, { headers });
    return this._commom.peticionGetConHeader(this.url);
  }

  getCountPage(resgistros: number): Observable<UsuarioSeguridadModel[]> {
    return this._commom.peticionGetConHeader(this.url + `/numero-pagina/${resgistros}`);
  }

  getAllProgresivo(resgistros: number, pagina: number): Observable<UsuarioSeguridadModel[]> {
    return this._commom.peticionGetConHeader(this.url + `/paginacion/${resgistros}/${pagina}`);
  }

  guardarUsuario(inUsuario: UsuarioSeguridadModel): Observable<UsuarioSeguridadModel> {
    // const headers = this._util.getHeaders();
    // return this.http.post<UsuarioSeguridadModel[]>(this.url, inUsuario, { headers });
    return this._commom.peticionPostConHeader(this.url, inUsuario);
  }

  actualizarUsuarioForce(inUsuario: UsuarioSeguridadModel): Observable<UsuarioSeguridadModel> {
    return this._commom.peticionPutConHeader(this.url+'/force', inUsuario);
  }

  actualizarUsuarioId(inUsuario: UsuarioSeguridadModel): Observable<UsuarioSeguridadModel> {
    // const headers = this._util.getHeaders();
    // return this.http.put<UsuarioSeguridadModel>(this.url, inUsuario, { headers });
    return this._commom.peticionPutConHeader(this.url, inUsuario);
  }

  eliminarUsuarioId(inId) {
    // const headers = this._util.getHeaders();
    // return this.http.delete(this.url + '/' + inId, { headers });
    return this._commom.peticionDeleteConHeader(this.url + `/${inId}`);
  }

  buscarUsuarioLdap(inId) {
    // const headers = this._util.getHeaders();
    // return this.http.get(this.urlLdap + inId, { headers }).pipe(
    //   map(res => res['respuesta'])
    // );
    return this._commom.peticionGetConHeader(this.urlLdap + inId);
  }

  buscarUsuarioCedulaOrLogin(login){
    return this._commom.peticionGetConHeader(this.url + `/${login}`);
  }

}
